<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5> {{ $t('Filters') }} </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2">
          <label>{{ $t('Category') }}</label>
          <v-select 
            class="w-100" 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            @input="(val) => $emit('update:categoriesFilter', val)"
            label="name"
            multiple 
            :options="categoriesOptions" 
            :reduce="val => val.id"
            :value="categoriesFilter"
          />
        </b-col>
        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Owners') }}</label>
          <v-select 
            class="w-100" 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            @input="(val) => $emit('update:ownersFilter', val)" 
            label="name" 
            multiple 
            :options="ownersOptions" 
            :reduce="val => val.id"
            :value="ownersFilter" 
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('types') }}</label>
          <v-select 
            class="w-100"
            :close-on-select="false"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="t => t.name" 
            @input="(val) => $emit('update:typeFilter', val)" 
            multiple  
            :options="typesOptions" 
            :reduce="val => val.id" 
            :value="typeFilter" 
          />
        </b-col>
        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Contracts') }}</label>
          <v-select 
            class="w-100"
            :close-on-select="false"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="c => c.name"
            @input="(val) => $emit('update:contractsFilter', val)"
            multiple 
            :options="contractsOptions" 
            :reduce="val => val.id"
            :value="contractsFilter"  
          />
        </b-col>
        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Support Devices') }}</label>
          <v-select 
            class="w-100"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            :getOptionLabel="c => $t(c.name)"
            :options="[{ id: 'all', name: 'all' }, { id: 'true', name: 'Support Devices' }, { id: 'false', name: 'Not Support devices' }]"
            :reduce="val => val.id" @input="(val) => $emit('update:isSupportFilter', val)" 
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'

import vSelect from 'vue-select'

import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import filterStore from '@/views/modules/Utils/filterStore'

export default {
  components: {
    BRow,
    BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    categoriesFilter: {
      type: Array,
    },
    contractsFilter: {
      type: Array,
    },
    ownersFilter: {
      type: Array,
    },
    typeFilter: {
      type: Array,
    }
  },
  setup(props, { root }) {

    const FILTER_STORE = 'filter'

    if (!store.hasModule(FILTER_STORE))
      store.registerModule(FILTER_STORE, filterStore)

    onUnmounted(() => {
      if (store.hasModule(FILTER_STORE))
            store.unregisterModule(FILTER_STORE)
    })

    const categoriesOptions = ref([])
    const contractsOptions = ref([])
    const ownersOptions = ref([])
    const typesOptions = ref([])

    const getFiltersOptions = () => {
      store.dispatch('filter/getFilterOptionsBy', { type:'device', hasRfid:true })
      .then( response => {
        const { categories, contracts, owners, types } = response.data.data
        categoriesOptions.value = categories.map((i) => ({ id: i, name: root.$t(i) }))
        contractsOptions.value = contracts
        ownersOptions.value = owners
        typesOptions.value = types
      })
    }

    getFiltersOptions()

    return {
      categoriesOptions,
      contractsOptions,
      ownersOptions,
      typesOptions
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
